import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as space from '../../../../space'
import * as award from '../award'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: award.RESOURCE.payload.dimension.partialId,
      partialId: award.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Space where this award is planned to be executed',
    isOptional: true,
    name: 'Planned Space',
    partialId: PartialId.Standard.create('space'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(space.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
